export const getOfferDetailsHref = (configUrl: string, dealRefId: string, lenderId: string): string => {
    const link = `${configUrl}/detail/FD/${dealRefId}/${lenderId}/`;
    return link;
};
